import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';
import { COMMON_TEXT } from '@/helpers/common-text';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import EmployeeLocationMap from './EmployeeLocationMap';
import EmployeeLocationList from './EmployeeLocationList';
import { Button } from 'primereact/button';

import { cloneDeep } from 'lodash';
import debounce from 'lodash/debounce';
import { Message } from 'primereact/message';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchDataByBranchId,
  fetchDataByCurrentBranchId,
  fetchEmployeeLocationByEmployeeIdList,
  fetchFollowedEmployeeIds,
} from './query-request';
import { MEMORY_STORE } from '@/helpers/constants';
import { isEmpty } from 'lodash';
import fileService from '@/services/file-service';
import { USER_ID_KEY } from '@/helpers/constants/users';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class EmployeeLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      floor:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0],
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      branch:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0],
      isLoading: false,

      // new below
      tabActiveIndex: 0,

      // List
      departmentList: [],
      departmentSearchText: '',
      teamSearchText: '',
      employeeSearchText: '',
      departmentActiveIndex: [],
      otherDepartmentActiveIndex: [],
      filteredEmpLocGroupedByDeptAndTeam: {},
      empLocGroupedByTeam: [],
      selectKeyTeam: '',

      // Map
      floorMapError: false,
      floorMapUrl: '',

      sidebarVisible: false,
      isDisplayAllDeviceChecked: false,

      // Follow functionality
      followedEmployeeIds: new Set(),
      isLoadingFollows: false,
    };
    this.branchName = '';
    this.employeeLocationList = [];
    this.empLocGroupedByDeptAndTeam = {};
    this.totalEmployeeMap = {};
    this.employeeLocationOptions = [
      {
        label: COMMON_TEXT.EMPLOYEE_LOCATIONS_LIST,
        value: 0,
      },
      {
        label: COMMON_TEXT.EMPLOYEE_LOCATIONS_MAP,
        value: 1,
      },
    ];
  }

  getFloorMapUrl = floorId => {
    const floors = this.props?.sessionStore[MEMORY_STORE.FLOORS] || [];
    const floor = floors.find(floor => floor.floor_id === floorId);
    const floorMap = floor?.floor_map_url ?? '';
    this.setState({ floorMapUrl: floorMap, floorMapError: isEmpty(floorMap) });
  };

  loadFollowedEmployeeIds = async () => {
    const { tenant } = this.state;

    // Get current user ID from session store
    const userId = this.props.sessionStore?.[USER_ID_KEY];

    if (!tenant || !userId) {
      console.warn('Missing tenant or user ID for loading followed employees');
      this.setState({ isLoadingFollows: false });
      return;
    }

    try {
      this.setState({ isLoadingFollows: true });
      const response = await fetchFollowedEmployeeIds({
        tenantId: tenant,
        userId: userId,
      });
      const employeeIds = response?.map(item => item.followee_employee_id);
      const followedIds = new Set(employeeIds);
      this.setState({
        followedEmployeeIds: followedIds,
      });

      const { hasInitializedFollowToggle } = this.state;
      if (!hasInitializedFollowToggle && followedIds.size > 0) {
        this.setState({
          isFollowersOnlyChecked: true,
          hasInitializedFollowToggle: true,
        });
      }
    } catch (error) {
      console.error('Error loading followed employees:', error);
      this.setState({ isLoadingFollows: false });
    }
  };

  handleFollowChange = (employeeId, isFollowing) => {
    const { followedEmployeeIds } = this.state;
    const newFollowedIds = new Set(followedEmployeeIds);

    if (isFollowing) {
      newFollowedIds.add(parseInt(employeeId));
    } else {
      newFollowedIds.delete(parseInt(employeeId));
    }

    this.setState({ followedEmployeeIds: newFollowedIds });
  };

  componentDidMount() {
    const { floor, branch, tenant } = this.state;
    if (floor && tenant && branch) {
      this.getFloorMapUrl(floor);
      this.getDataByBranchId();
      this.loadFollowedEmployeeIds();
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const floor = querystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0];
    const branch = querystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevFloor =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0];
    const prevBranch =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const isFloorChanged = floor !== prevFloor;
    const isBranchChanged = branch !== prevBranch;
    if (isBranchChanged || isFloorChanged) {
      this.setState({ branch, tenant, floor }, () => {
        this.getFloorMapUrl(floor);
        this.getDataByBranchId();
        this.loadFollowedEmployeeIds();
      });
    }

    const prevUserId = prevProps.sessionStore?.[USER_ID_KEY];
    const currentUserId = this.props.sessionStore?.[USER_ID_KEY];
    if (currentUserId && currentUserId !== prevUserId && tenant) {
      this.loadFollowedEmployeeIds();
    }
  }

  groupEmployeeToDepartmentAndTeam = ({ dataArray, branchId }) => {
    let resultMap = {
      [branchId]: {},
    };
    // Group the data
    dataArray.forEach(employeeInfo => {
      let { department, team, current_branch_id, base_branch_id } =
        employeeInfo;

      if (!current_branch_id) {
        current_branch_id = 'NO_GROUP'; // 他拠点
      }

      if (!department) {
        department = 'NO_DEPARTMENT'; // 部署なし
      }
      if (!team) {
        team = 'NO_TEAM'; // チームなし
      }

      if (branchId !== base_branch_id && branchId === current_branch_id) {
        if (!resultMap['NO_GROUP']) {
          resultMap['NO_GROUP'] = {};
        }

        if (!resultMap['NO_GROUP'][department]) {
          resultMap['NO_GROUP'][department] = {};
        }

        if (!resultMap['NO_GROUP'][department][team]) {
          resultMap['NO_GROUP'][department][team] = [];
        }

        resultMap['NO_GROUP'][department][team].push(employeeInfo);
      } else if (branchId === base_branch_id) {
        if (!resultMap[base_branch_id]) {
          resultMap[base_branch_id] = {};
        }

        if (!resultMap[base_branch_id][department]) {
          resultMap[base_branch_id][department] = {};
        }

        if (!resultMap[base_branch_id][department][team]) {
          resultMap[base_branch_id][department][team] = [];
        }
        resultMap[base_branch_id][department][team].push(employeeInfo);
      }
    });

    const totalEmployeeMap = {};
    // count the number of employees for each department
    Object.keys(resultMap).forEach(groupName => {
      Object.keys(resultMap[groupName]).forEach(department => {
        if (!totalEmployeeMap[groupName]) {
          totalEmployeeMap[groupName] = {};
        }
        let employeeCount = 0;
        Object.keys(resultMap[groupName][department]).forEach(team => {
          const employeeList = resultMap[groupName][department][team];
          const employeeIdSet = new Set(
            employeeList.map(item => item.employee_id)
          );
          employeeCount += employeeIdSet.size;
          if (!totalEmployeeMap[groupName][department]) {
            totalEmployeeMap[groupName][department] = {
              count: 0,
              [team]: 0,
            };
          }
          totalEmployeeMap[groupName][department][team] = employeeIdSet.size;
        });
        totalEmployeeMap[groupName][department]['count'] = employeeCount;
      });
    });

    // if resultMap has no key is NO_DEPARTMENT, add NO_DEPARTMENT
    if (!resultMap['NO_GROUP']) {
      resultMap['NO_GROUP'] = {};
    }

    return {
      empLocGroupedByDeptAndTeam: resultMap,
      totalEmployeeMap,
    };
  };

  getBranchName = ({ branchId }) => {
    const { sessionStore } = this.props;
    const branches = sessionStore[MEMORY_STORE.BRANCHES] || [];
    if (branchId) {
      const foundBranches = branches.filter(
        branch => branch.branch_id === branchId
      );
      return foundBranches?.[0]?.branch_name ?? '-';
    }
    return '-';
  };

  setEmployeeLocationListState = (employeeLocationList, callback) => {
    employeeLocationList = cloneDeep(employeeLocationList);
    const { empLocGroupedByDeptAndTeam, totalEmployeeMap } =
      this.groupEmployeeToDepartmentAndTeam({
        dataArray: employeeLocationList,
        branchId: this.state.branch,
      });

    this.empLocGroupedByDeptAndTeam = cloneDeep(empLocGroupedByDeptAndTeam);
    this.totalEmployeeMap = cloneDeep(totalEmployeeMap);

    let newGroupList = Object.keys(this.empLocGroupedByDeptAndTeam)
      .filter(item => item !== 'NO_GROUP')
      .sort((a, b) => {
        return a.localeCompare(b, 'ja');
      });
    newGroupList.push('NO_GROUP');

    const newUpdatedState = {
      data: employeeLocationList,
      departmentList: newGroupList,
      filteredEmpLocGroupedByDeptAndTeam: cloneDeep(
        this.empLocGroupedByDeptAndTeam
      ),
      isLoading: false,
    };
    this.setState(newUpdatedState, callback);
  }

  getDataByBranchId = async () => {
    const { tenant, branch, floor: selectedFloorId } = this.state;
    if (!tenant || !branch || !selectedFloorId) {
      return;
    }
    this.setState({ isLoading: true });
    this.branchName = this.getBranchName({ branchId: branch });
    let [employeeDataByBranch, employeeDataByCurrentBranch] = await Promise.all([
      fetchDataByBranchId({
        branchId: branch,
        tenantId: tenant,
      }),
      fetchDataByCurrentBranchId({
        currentBranchId: branch,
        tenantId: tenant,
      })
    ]);

    if (!employeeDataByBranch) {
      employeeDataByBranch = [];
    }
    if (!employeeDataByCurrentBranch) {
      employeeDataByCurrentBranch = [];
    }

    // filter out employee data by tenant
    employeeDataByBranch = employeeDataByBranch.filter(
      item => +item['tenant_id'] === +tenant
    );
    employeeDataByCurrentBranch = employeeDataByCurrentBranch.filter(
      item => +item['tenant_id'] === +tenant
    );

    // Get all employee images at once for better performance
    const allEmployees = [...employeeDataByBranch, ...employeeDataByCurrentBranch];
    const imageKeys = allEmployees
      .filter(emp => emp.employee_image)
      .map(emp => emp.employee_image);
    // Start loading images ASAP (before setState)
    let fileUrlsPromise = null;
    if (imageKeys.length > 0) {
      fileUrlsPromise = fileService.getFileUrls(imageKeys);
    }

    // Default images first (synchronous)
    employeeDataByBranch.forEach(employee => {
      const { current_branch_id: emplCurrentBranchId } = employee;
      const { current_floor_id: emplCurrentFloorId } = employee;
      employee['is_present'] = +emplCurrentBranchId === +branch;
      employee['is_out_of_office'] = !emplCurrentFloorId;
      employee['employee_image_url'] = 'assets/images/default_employee_avatar.jpg';
    });

    employeeDataByCurrentBranch.forEach(employee => {
      const { current_branch_id: emplCurrentBranchId } = employee;
      const { current_floor_id: emplCurrentFloorId } = employee;
      employee['is_present'] = +emplCurrentBranchId === +branch;
      employee['is_out_of_office'] = !emplCurrentFloorId;
      employee['employee_image_url'] = 'assets/images/default_employee_avatar.jpg';
    });

    // Handle check duplicate data and merge
    const duplicatesId = employeeDataByBranch
      .filter(value =>
        employeeDataByCurrentBranch.some(
          oneElement =>
            oneElement.base_branch_id === value.base_branch_id &&
            oneElement.employee_name === value.employee_name
        )
      )
      .map(oneElement => oneElement.base_branch_id);

    employeeDataByBranch = [
      ...employeeDataByBranch,
      ...employeeDataByCurrentBranch.filter(
        value =>
          !duplicatesId.some(
            oneDuplicate => oneDuplicate === value.base_branch_id
          )
      ),
    ];

    // Extract presence employee id list
    const presenceEmployeeIdList = employeeDataByBranch
      .filter(employee => employee['is_present'])
      .map(employee => +employee['employee_id']);

    // Fetch coordinate by employee id list
    let employeeCoordinateListPromise = fetchEmployeeLocationByEmployeeIdList({
      employeeIdList: presenceEmployeeIdList,
      tenantId: tenant,
      floorId: selectedFloorId,
    });

    // set employeeLocationList, totalEmployeeMap
    this.employeeLocationList = cloneDeep(employeeDataByBranch);

    for (const employee of this.employeeLocationList) {
      employee['location_info'] = [];
    }

    this.setEmployeeLocationListState(this.employeeLocationList, () => {
      if (fileUrlsPromise) {
        fileUrlsPromise.then(fileUrls => {
          for (const employee of this.employeeLocationList) {
            if (employee.employee_image && fileUrls[employee.employee_image]) {
              employee['employee_image_url'] = fileUrls[employee.employee_image];
            }
          }
          this.setEmployeeLocationListState(this.employeeLocationList);
        });
      }

      if (employeeCoordinateListPromise) {
        employeeCoordinateListPromise.then(employeeCoordinateList => {
          if (!employeeCoordinateList) {
            employeeCoordinateList = [];
          }
          for (const employee of this.employeeLocationList) {
            const { employee_id } = employee;
            const employeeLocations = employeeCoordinateList.filter(
              item => +item['employee_id'] === +employee_id
            );
            employee['location_info'] = employeeLocations ?? [];
          }
          this.setEmployeeLocationListState(this.employeeLocationList);
        });
      }
    });
  };

  renderMessageError = () => {
    const { floor } = this.state;
    if (!floor) {
      return (
        <Message
          severity="error"
          text={COMMON_TEXT.FLOOR_NOT_SELECTED_PLEASE_SELECT}
          className="mb-3"
        />
      );
    }
  };

  refreshData() {
    const { floor } = this.state;
    this.getFloorMapUrl(floor);
    this.getDataByBranchId();
    this.setState({
      // List
      departmentSearchText: '',
      teamSearchText: '',
      employeeSearchText: '',
      departmentActiveIndex: [],
      otherDepartmentActiveIndex: [],
      filteredEmpLocGroupedByDeptAndTeam: {},
      empLocGroupedByTeam: [],
      selectKeyTeam: '',

      // Map
      sidebarVisible: false,
      isDisplayAllDeviceChecked: false,
    });
  }

  renderRefreshButton() {
    const { isLoading, floor } = this.state;
    return (
      <Button
        label={COMMON_TEXT.REFRESH_BUTTON_TEXT}
        loading={isLoading}
        disabled={!floor}
        className="refresh-button has-shadow"
        severity="info"
        size="small"
        onClick={() => this.refreshData()}
      />
    );
  }

  updateAllDeviceChecked = ({ isCheck }) => {
    this.setState({ isDisplayAllDeviceChecked: isCheck });
  };

  updateFollowersOnlyChecked = (isCheck) => {
    this.setState({
      isFollowersOnlyChecked: isCheck,
      hasInitializedFollowToggle: true,
    });
  };

  updateSearchTextChange = ({ value, type }) => {
    switch (type) {
      case 'department':
        this.setState({
          departmentSearchText: value,
        });
        break;
      case 'team':
      case 'room': // Map room search to team search
        this.setState({
          teamSearchText: value,
        });
        break;
      case 'employee':
        this.setState({
          employeeSearchText: value,
        });
        break;
      default:
        break;
    }
    // Map room type to team for the search logic
    const searchType = type === 'room' ? 'team' : type;
    this.handleSearchTextChange({ value: value.trim(), type: searchType });
  };

  handleSearchTextChange = debounce(({ value, type }) => {
    const keys = [
      'department',
      'team',
      'employee_number',
      'employee_name',
      'employee_name_reading',
      'phone_number',
      'phone_number2',
      'email',
    ];

    const getFilteredValue = ({ filterText, employeeList }) => {
      let newValues = [];

      const newEmployees = employeeList.filter(employee =>
        keys.some(
          key =>
            employee[key] &&
            employee[key]
              .toLocaleLowerCase()
              .includes(filterText.toLocaleLowerCase())
        )
      );

      if (newEmployees != null && newEmployees.length > 0) {
        newValues = [...newValues, ...newEmployees];
      }

      return newValues;
    };
    const searchText = value;
    let {
      departmentSearchText: currentDepartmentSearchText,
      teamSearchText: currentTeamSearchText,
      employeeSearchText: currentEmployeeSearchText,
      selectKeyTeam,
    } = this.state;

    // Remove space text search
    currentDepartmentSearchText = currentDepartmentSearchText.trim();
    currentTeamSearchText = currentTeamSearchText.trim();
    currentEmployeeSearchText = currentEmployeeSearchText.trim();

    if (type === 'department') {
      currentDepartmentSearchText = searchText;
    } else if (type === 'team') {
      currentTeamSearchText = searchText;
    } else if (type === 'employee') {
      currentEmployeeSearchText = searchText;
    }

    // filter employee by search department/team text
    const filteredEmpLocGroupedByDeptAndTeam = cloneDeep(
      this.empLocGroupedByDeptAndTeam
    );
    // filter employee by search employee text
    const filteredEmpLocGroupedByEmployee = cloneDeep(
      this.empLocGroupedByDeptAndTeam
    );
    let filteredEmpLocGroupedByTeam = [];

    let groupList = Object.keys(filteredEmpLocGroupedByDeptAndTeam);
    if (currentDepartmentSearchText.length > 0) {
      // filter filteredEmpLocGroupedByDeptAndTeam by departmentSearchText
      groupList.forEach(groupName => {
        const departmentMap = filteredEmpLocGroupedByDeptAndTeam[groupName];
        if (!departmentMap) {
          return;
        }
        const departmentList = Object.keys(departmentMap);
        let isTeamHasMatchedEmployee = false;
        departmentList.forEach(departmentName => {
          if (
            !departmentName
              .toLocaleLowerCase()
              .includes(currentDepartmentSearchText.toLocaleLowerCase())
          ) {
            delete filteredEmpLocGroupedByDeptAndTeam[groupName][
              departmentName
            ];
          } else {
            isTeamHasMatchedEmployee = true;
          }
        });
        if (!isTeamHasMatchedEmployee) {
          delete filteredEmpLocGroupedByDeptAndTeam[groupName];
        }

        // Check list department when delete
        const newDepartmentList = Object.keys(departmentMap);
        if (newDepartmentList.length === 0) {
          delete filteredEmpLocGroupedByDeptAndTeam[groupName];
        }
      });
    }

    if (currentTeamSearchText.length > 0) {
      groupList.forEach(groupName => {
        const departmentMap = filteredEmpLocGroupedByDeptAndTeam[groupName];
        if (!departmentMap) {
          return;
        }
        const departmentList = Object.keys(departmentMap);
        departmentList.forEach(departmentName => {
          const teamMap =
            filteredEmpLocGroupedByDeptAndTeam[groupName][departmentName];
          if (!teamMap) {
            return;
          }
          const teamList = Object.keys(teamMap);
          let isTeamHasMatchedEmployee = false;
          teamList.forEach(teamName => {
            if (
              !teamName
                .toLocaleLowerCase()
                .includes(currentTeamSearchText.toLocaleLowerCase())
            ) {
              delete filteredEmpLocGroupedByDeptAndTeam[groupName][
                departmentName
              ][teamName];
            } else {
              isTeamHasMatchedEmployee = true;
            }
          });
          if (!isTeamHasMatchedEmployee) {
            delete filteredEmpLocGroupedByDeptAndTeam[groupName][
              departmentName
            ];
          }
        });

        // Check list department when delete
        const newDepartmentList = Object.keys(departmentMap);
        if (newDepartmentList.length === 0) {
          delete filteredEmpLocGroupedByDeptAndTeam[groupName];
        }
      });
    }

    if (currentEmployeeSearchText.length > 0) {
      groupList.forEach(groupName => {
        const departmentMap = filteredEmpLocGroupedByEmployee[groupName];
        if (!departmentMap) {
          return;
        }
        const departmentList = Object.keys(departmentMap);
        departmentList.forEach(departmentName => {
          const teamMap =
            filteredEmpLocGroupedByEmployee[groupName][departmentName];
          if (!teamMap) {
            return;
          }
          const teamList = Object.keys(teamMap);
          teamList.forEach(teamName => {
            const employeeList =
              filteredEmpLocGroupedByEmployee[groupName][departmentName][
              teamName
              ];

            const filteredEmployeeList = getFilteredValue({
              filterText: currentEmployeeSearchText,
              employeeList,
            });

            if (
              filteredEmployeeList != null &&
              filteredEmployeeList.length > 0
            ) {
              filteredEmpLocGroupedByTeam = [
                ...filteredEmpLocGroupedByTeam,
                ...filteredEmployeeList,
              ];
            }
          });
        });
      });
    } else if (selectKeyTeam.length > 0) {
      if (selectKeyTeam === 'FOLLOWED_EMPLOYEES') {
        const { followedEmployeeIds } = this.state;
        filteredEmpLocGroupedByTeam = this.employeeLocationList.filter(emp =>
          followedEmployeeIds.has(parseInt(emp.employee_id))
        );
      } else {
        groupList.forEach(groupName => {
          const departmentMap = filteredEmpLocGroupedByDeptAndTeam[groupName];
          if (!departmentMap) {
            return;
          }
          const departmentList = Object.keys(departmentMap);
          departmentList.forEach(departmentName => {
            const teamMap =
              filteredEmpLocGroupedByDeptAndTeam[groupName][departmentName];
            if (!teamMap) {
              return;
            }
            const teamList = Object.keys(teamMap);

            // Check if this department matches the 'All Employees' selection
            const allEmployeesKey = `${groupName}###${departmentName}###ALL_EMPLOYEES`;
            if (selectKeyTeam === allEmployeesKey) {
              const allEmployees = [];
              Object.values(teamMap).forEach(list => allEmployees.push(...list));
              filteredEmpLocGroupedByTeam = allEmployees;
              return;
            }

            teamList.forEach(teamName => {
              const key = `${groupName}###${departmentName}###${teamName}`;
              if (selectKeyTeam !== key) {
                return;
              }

              const employeeList =
                filteredEmpLocGroupedByDeptAndTeam[groupName][departmentName][
                teamName
                ];
              filteredEmpLocGroupedByTeam = employeeList;
            });
          });
        });
      }
    }

    let newGroupList = Object.keys(filteredEmpLocGroupedByDeptAndTeam).sort(
      (a, b) => {
        return a.localeCompare(b, 'ja');
      }
    );

    if (type === 'department') {
      this.setState({
        departmentList: newGroupList,
        filteredEmpLocGroupedByDeptAndTeam,
      });
    } else if (type === 'team') {
      this.setState({
        departmentList: newGroupList,
        filteredEmpLocGroupedByDeptAndTeam,
      });
    } else if (type === 'employee') {
      this.setState({
        empLocGroupedByTeam: filteredEmpLocGroupedByTeam,
      });
    }
  }, 500);

  updateSelectKeyTeam = ({
    selectKeyTeam,
    empLocGroupedByTeam,
    employeeSearchText,
  }) => {
    this.setState({
      selectKeyTeam,
      empLocGroupedByTeam,
      employeeSearchText,
    });
  };

  updateActiveIndex = ({ isOther, index }) => {
    switch (isOther) {
      case true:
        this.setState({ otherDepartmentActiveIndex: index });
        break;
      default:
        this.setState({ departmentActiveIndex: index });
        break;
    }
  };

  renderTabSwitcher = () => {
    const { tabActiveIndex } = this.state;

    return (
      <div className="tab-container">
        <div className="tab-wrapper">
          <div
            className={`tab-button ${tabActiveIndex === 0 ? 'active' : ''}`}
            onClick={() => this.setState({ tabActiveIndex: 0 })}
          >
            リスト
          </div>
          <div
            className={`tab-button ${tabActiveIndex === 1 ? 'active' : ''}`}
            onClick={() => this.setState({ tabActiveIndex: 1 })}
          >
            マップ
          </div>
        </div>
        <div className="refresh-button" onClick={() => this.refreshData()}>
          <i className="pi pi-refresh" />
        </div>
      </div>
    );
  };



  render() {
    const {
      data: floorMapData,
      tenant,
      floor,
      branch,
      isLoading,
      filteredEmpLocGroupedByDeptAndTeam,
      departmentList,
      tabActiveIndex,
      floorMapError,
      floorMapUrl,
      departmentSearchText,
      teamSearchText,
      employeeSearchText,
      empLocGroupedByTeam,
      isDisplayAllDeviceChecked,
      departmentActiveIndex,
      otherDepartmentActiveIndex,
      selectKeyTeam,
    } = this.state;

    return (
      <div className="employee-locations-v3">
        <div className="main-container">
          <div className="unified-content-panel">
            {this.renderTabSwitcher()}

            <div className="content-area">
              {isLoading ? (
                <LoadingSpinner />
              ) : (
                <>
                  {tabActiveIndex === 0 && (
                    <div className="unified-employee-interface">
                      <EmployeeLocationList
                        isLoading={isLoading}
                        departmentList={departmentList}
                        empLocGroupedByTeam={empLocGroupedByTeam}
                        departmentActiveIndex={departmentActiveIndex}
                        otherDepartmentActiveIndex={otherDepartmentActiveIndex}
                        selectKeyTeam={selectKeyTeam}
                        filteredEmpLocGroupedByDeptAndTeam={filteredEmpLocGroupedByDeptAndTeam}
                        employeeSearchText={employeeSearchText}
                        departmentSearchText={departmentSearchText}
                        teamSearchText={teamSearchText}
                        branchName={this.branchName}
                        totalEmployeeMap={this.totalEmployeeMap}
                        allEmployees={this.employeeLocationList}
                        followedEmployeeIds={this.state.followedEmployeeIds}
                        onFollowChange={this.handleFollowChange}
                        updateSearchTextChange={this.updateSearchTextChange}
                        updateSelectKeyTeam={this.updateSelectKeyTeam}
                        updateActiveIndex={this.updateActiveIndex}
                        onRefresh={() => this.refreshData()}
                        renderMode="unified"
                      />
                    </div>
                  )}
                  {tabActiveIndex === 1 && (
                    <EmployeeLocationMap
                      data={floorMapData}
                      floor={floor}
                      branch={branch}
                      tenant={tenant}
                      isLoading={isLoading}
                      floorMapError={floorMapError}
                      floorMapUrl={floorMapUrl}
                      isDisplayAllDeviceChecked={isDisplayAllDeviceChecked}
                      updateAllDeviceChecked={this.updateAllDeviceChecked}
                      followedEmployeeIds={this.state.followedEmployeeIds}
                      onFollowChange={this.handleFollowChange}
                      isFollowersOnlyChecked={this.state.isFollowersOnlyChecked}
                      onFollowersOnlyChange={this.updateFollowersOnlyChecked}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EmployeeLocations.propTypes = {};

export default EmployeeLocations;
